import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const MobileCalculationsResult = props => {
  const { mortgagePayment } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Box display="flex" width="100%" justifyContent="center">
        <Typography variant="h2" color="inherit" className={classes.text}>
          {`${t('components.MothlyPaymentCalculator.DesktopCalculationsResult.mortgagePayment')}:`}
        </Typography>
        <Typography variant="h2" className={classes.homePrice}>
          {mortgagePayment}
        </Typography>
      </Box>
      <Box className={classes.divider} />
    </Box>
  );
};

MobileCalculationsResult.propTypes = {
  mortgagePayment: PropTypes.string.isRequired,
};

export default MobileCalculationsResult;



// WEBPACK FOOTER //
// ./src/sharedComponents/MothlyPaymentCalculator/components/MobileCalculationsResult/MobileCalculationsResult.js